import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Preserves query params when redirecting legacy /landing URLs to /home.
 */
const LandingToHomeRedirect = () => {
  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString();
  const to = queryString ? `/home?${queryString}` : '/home';
  return <Navigate to={to} replace />;
};

export default LandingToHomeRedirect;
